import * as React from "react"
import { Box, chakra } from "@chakra-ui/react"
import { Link } from "gatsby"

const ChakraLink = chakra(Link)

type LogoProps = {
  size?: "md" | "lg"
  to?: string
}

const Logo: React.FC<LogoProps> = ({ size = "lg", to = "/" }) => {
  const fontSize = size === "md" ? "1.15rem" : "1.5rem"

  return (
    <ChakraLink
      to={to}
      display="flex"
      alignItems="center"
      gap="1px"
      fontWeight="800"
      fontSize={fontSize}
      letterSpacing="-0.5px"
      color="gray.900"
      textDecoration="none"
      _hover={{ textDecoration: "none" }}
    >
      spot
      <Box as="span" color="brand.400">
        .
      </Box>
    </ChakraLink>
  )
}

export default Logo
